// Contains layout times used in routing modules.
// Shared here in the case that new properties need to be added

/**
 * Layout for admin with footer.
 */
export const ADMIN_WITH_FOOTER = { headerType: 'admin', hideFooter: false};

export const ADMIN_NO_FOOTER = { headerType: 'admin', hideFooter: true};

export const CAMPAIGN_NO_FOOTER = { headerType: 'campaign', hideFooter: true};

export const CAMPAIGN_WITH_FOOTER = { headerType: 'campaign', hideFooter: false};

export const NO_TABS = { headerType: 'no_tabs', hideFooter: false};
